import PropTypes from 'prop-types';
import React, {Component} from 'react';

import LabeledInput from '../../components/forms/LabeledInput'
import {reduxForm} from 'redux-form'

import {validateAlternateSepa as validate} from '../../util/validate'

import * as ActionTypes from '../../constants/ActionTypes'
import {queryBankAccountVerification, setVerifiedBankAccount} from "../../actions/AlternateSepaInput";

const asyncValidate = (values, dispatch) => {


    return new Promise((resolve, reject) => {

        let errors = {}

        if (!values.accountHolder) {
            errors.accountHolder = "Bitte gib einen Kontoinhaber an."
        } else if (values.accountHolder.length < 2) {
            errors.accountHolder = "Bitte gib einen gültigen Kontoinhaber an."
        }

        if (!values.accountNumber) {
            errors.accountNumber = "Bitte gib deine Kontonummer an."
        }

        if (!values.bankAddress) {
            errors.bankAddress = "Bitte gib die Bankleitzahl deiner Bank an."
        }

        if (Object.keys(errors).length) {
            reject(errors)
            return
        }

        dispatch(queryBankAccountVerification(values.accountNumber, values.bankAddress)).then(result => {
            if (result.type === ActionTypes.BANKACCOUNT_VERIFY_FAILURE) {
                if (result.error === "Given bank data invalid!" || result.error === "Error on iban generation!") {
                    errors._error = "data-invalid"
                    errors.accountNumber = "Bitte überprüfe die Kontonummer."
                    errors.bankAddress = "Bitte überprüfe die Bankleitzahl."

                    reject(errors)
                    return
                }
            }
            dispatch(setVerifiedBankAccount(values.accountHolder, result.response.result.iban, result.response.result.bic))
            resolve()
        })

    })

}

class AlternateSepaForm extends Component {


    static propTypes = {
        forceValidation: PropTypes.bool
    }

    static defaultProps = {
        forceValidation: false
    }


    shouldComponentUpdate(nextProps, nextState) {

        if (this.props.forceValidation !== nextProps.forceValidation) {
            return true
        }

        return false

    }

    render() {
        return (

            <form className="payment-step__sepa-input payment-step__sepa-input--alternate">
                <LabeledInput forceValidation={this.props.forceValidation} fieldId="accountHolder" label="Kontoinhaber" placeholder="Vorname Nachname"/>
                <LabeledInput forceValidation={this.props.forceValidation} fieldId="accountNumber" label="Kontonummer" placeholder="Deine Kontonummer"/>
                <LabeledInput forceValidation={this.props.forceValidation} fieldId="bankAddress" label="Bankleitzahl" placeholder="Die Bankleitzahl deiner Bank"/>
            </form>

        )
    }
}


AlternateSepaForm = reduxForm({form: 'alternateSepaPayment', destroyOnUnmount: false, validate, asyncValidate})(AlternateSepaForm)

export default AlternateSepaForm



/** WEBPACK FOOTER **
 ** ./src/containers/payment/AlternateSepaForm.js
 **/